import { useContext } from "react";
import C from "classnames";

import { ThemeContext, ThemeContextType } from "../ThemeContext";

import legacyLogo from "../../assets/sjLogos/security-journey-white-logo.svg";
import atlasLightLogo from "../../assets/sjLogos/sj-logo-atlas-light.svg";
import atlasDarkLogo from "../../assets/sjLogos/sj-logo-atlas-dark.svg";

import S from "./_ThemeLogo.module.scss";

export const ThemeLogo = () => {
  const { appliedTheme } = useContext(ThemeContext) as ThemeContextType;

  if (!appliedTheme) {
    return null;
  }

  let themeLogo = legacyLogo;
  if (appliedTheme === "atlas-light") {
    themeLogo = atlasLightLogo;
  } else if (appliedTheme === "atlas-dark") {
    themeLogo = atlasDarkLogo;
  }

  return (
    <a href="/">
      <img
        alt="Security Journey Logo"
        src={themeLogo}
        className={C(S.LoginLogo, {
          [S.AtlasLogo]: appliedTheme === "atlas-light" || appliedTheme === "atlas-dark",
        })}
      />
    </a>
  );
};
